.topAlignedDialog {
  margin-block-start: 25px;
  margin-block-end: auto;
}

.searchInputContainer {
  position: relative;
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center;
}

.searchInput {
  border: 0;
  margin: 0;
  caret-color: var(--colorPrimary);
  flex: 1;
  font-size: 14px;
  height: 30px;
  padding: 0;
  width: 100%;
  outline: none;
  background-color: transparent;
}

.searchInputButton {
  align-items: center;
  background-color: transparent;
  border-radius: 10px;
  border: 0;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  min-width: 30px;
  position: absolute;
  inset-inline-end: 0;
}

.searchInputButtonIcon {
  background-color: currentcolor;
}